/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';

export const useOrderDetails = ({ orderId }: any) => {
  const variables = {
    orderId: orderId 
  };
  const ORDERDETAIL_GQL = gql`
  query OrderDetail($orderId: String) {
    me {
      orderDetail(orderID: $orderId) {
        orderNumber
        orderExtendAttribute {
        attributeName
        attributeValue
      }
        paymentAccountDetails
        paymentCardType
        address
        email
        firstName
        grandTotal {
          currency
          value
        }
        totalProductPrice {
          currency
          value
        }
        totalAdjustment {
          currency
          value
        }
        totalSalesTax{
          currency
          value
        }
        taxes {
          currency
          value
        }
        totalShippingCharge {
          currency
          value
        }
        id
        status
        placedDate
        paymentMethod
        lastName
        idIssuer
        idType
        lineItems {
          quantity
          id
          status
          item {
            name
            fullImage
            id
            longDescription
            partnumber
          }
          partnumber
          linePrice {
            currency
            value
          }
          unitPrice {
            currency
            value
          }
          attributes {
            name
            value
          }
          shippingMethod {
            id
            identifier
            description
          }
        }
        billingAddress {
          id
          title
          titleCode
          address1
          address2
          city
          company
          country
          countryCode
          countryName
          firstName
          lastName
          name
          phone
          province
          zip
          email
          availableForShipping
          availableForBilling
          address3
          phoneExt
          identification
          dateOfBirth
          personTitle
          businessTitle
          orderId
          storeField1
          storeField2
        }
        shippingAddress {
          id
          title
          titleCode
          address1
          address2
          city
          company
          country
          countryCode
          countryName
          firstName
          lastName
          name
          phone
          province
          zip
          email
          availableForShipping
          availableForBilling
          address3
          phoneExt
          identification
          dateOfBirth
          personTitle
          businessTitle
          orderId
          storeField1
          storeField2
        }
        paymentInstructions {
          paymentMethod {
            id
            identifier
            description
            type
          }
          id
          amount
        }
        adjustments {
          title
          amount {
            value
            currency
          }
          type
        }
        updateDate
        
      }
    }
  }
  `;

  const { data, loading, error } = useQuery(ORDERDETAIL_GQL, {
    variables,
    fetchPolicy: "cache-and-network",

     context:{
          clientName:"/account/order-details"
        }
  });

  return { data, loading, error };
};
